import { render, staticRenderFns } from "./LayoutMenuLink.vue?vue&type=template&id=423bc822"
import script from "./LayoutMenuLink.vue?vue&type=script&lang=js"
export * from "./LayoutMenuLink.vue?vue&type=script&lang=js"
import style0 from "./LayoutMenuLink.vue?vue&type=style&index=0&id=423bc822&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports